import differenceInDays from 'date-fns/differenceInDays';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';

/**
 * Calculates the days left in a campaign relative to a specific date.
 *
 * This counts the number of whole days left until the campaign ends. For example: If today is Monday and
 * the campaign ends on Wednesday, the result is 2, since two full days (Tuesday and Wednesday) remain.
 */
export function daysLeftInCampaign(from: Date, campaignEndDate: Date) {
    if (!from || !campaignEndDate) {
        return 0;
    }

    const startFrom = startOfDay(from);
    const startCampaignEndDate = startOfDay(campaignEndDate);

    if (isBefore(startCampaignEndDate, startFrom)) {
        return 0;
    }

    return differenceInDays(startCampaignEndDate, startFrom);
}

/**
 * Calculates the days left in a campaign from today.
 */
export function daysLeftInCampaignFromNow(campaignEndDate: Date) {
    return daysLeftInCampaign(new Date(), campaignEndDate);
}
